import { Outlet } from "react-router-dom";

export default function AdminApp() {
  return <Outlet />;
}
